import { getDataMapper, mapField } from "@/shared";

export const mapDirectorHealthFromServer = getDataMapper({
    score: mapField("score", Number),
    label: mapField("label"),
});
